import { BillingInfo } from "./billing-info.model";
import { InventoryActionProduct } from "./inventory-action-product";
import { Status } from "./status.model";
import { Work } from "./work.model";

export interface Invoice {
  id: number;
  cancelled_at: Date;
  completed_at: Date;
  correlative_id: number;
  created_at: Date;
  data: InvoiceData;
  document: any;
  document_id: number;
  draft: boolean;
  due_date: Date;
  finish: boolean;
  folio_number: number;
  invoice_type: string;
  is_buy: boolean;
  payment_method: string;
  stakeholder: InvoiceStakeholder;
  stakeholder_id: number;
  stakeholder_type: string;
  status: Status;
  status_id: number;
  total: number;
  type: string;
  url: string;
  validated_at: Date;
  works: Work[];
}

interface InvoiceData {
  client: InvoiceDataClient;
  details: InventoryActionProduct[];
  payment: InvoiceDataPayment;
  billing_info: BillingInfo;
}

interface InvoiceDataClient {
  code: string;
  city: string;
  municipality: string;
  address: string;
  activity: string;
  email: string;
  phone: string;
}

interface InvoiceStakeholder {
  id: number;
  name: string;
  type: string;
  rut: string;
  phone: string;
  email: string;
}

interface InvoiceDataPayment {
  payment_method: string;
  due_date: Date;
  amount: number;
  receipt_number: string;
}

export const INVOICE_TYPES = [
  'electronic_invoice',
  'electronic_ticket',
]
